export enum RulesKeys {
  GET_CONF = "GET_CONF",
  GET_CONTACT_ITEMS ="GET_CONTACT_ITEMS",
  GET_VIEW_DATA_CONFIGURATION = "GET_VIEW_DATA_CONFIGURATION",
  GET_FOOTER_CONF= "GET_FOOTER_CONF",
}